"use client";

import viugoTrendDown from "@/assets/images/viugo/kbv-v16-trend-arrow-down.svg";
import viugoTrendUp from "@/assets/images/viugo/kbv-v16-trend-arrow-up.svg";
import { hasDirectionalTrend, isValidOddValue, normalizeTrend } from "./ViuGoTrendUtils";

function TrendArrow({ isDown }) {
    return (
        <img src={isDown ? viugoTrendDown : viugoTrendUp} alt="" width={6} height={5} className="shrink-0" aria-hidden />
    );
}

export default function ViuGoOddsMatchCell({
    label,
    value,
    trend,
    labelClassName = "text-[9px] leading-[12px] text-[var(--theme-text-muted)]",
    valueClassName = "text-[12px] leading-[12px]",
}) {
    const normalizedTrend = normalizeTrend(trend);
    const isDown = normalizedTrend === "down";
    const display = isValidOddValue(value) ? value : "-";

    return (
        <div
            className={`block w-full min-w-0 !w-full !min-w-0 !flex justify-between rounded-[2px] px-1 py-[2px] font-normal ${isDown ? "kbv-bg-odds-positive-indigo-slate" : "kbv-bg-odds-neutral-indigo-slate"
                }`}
        >
            <div className={labelClassName}>{label ?? ""}</div>
            <div className={`inline-flex items-center gap-[3px] ${valueClassName}`}>
                {display}
                {isValidOddValue(display) && hasDirectionalTrend(trend) && (
                    <TrendArrow isDown={isDown} />
                )}
            </div>
        </div>
    );
}

